import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OverviewState } from '../../models/overview.model';

export const getOverviewState = createFeatureSelector<OverviewState>('overview');

export const getLabResults = createSelector(
  getOverviewState,
  (state: OverviewState) => state.labResults,
);
